module.exports = __webpack_public_path__ + "static/img/cont43_06.1ad4f82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_06.jpg
// module id = qAa2
// module chunks = 0